import { createItem } from './createItem'
import { GTMResetEcommerce } from './gtmResetEcommerce'
import { ShopifyResolvedCartLine } from '@sans-souci/shopify-sdk'

export const GTMRemoveFromCart = (
  cartLine: ShopifyResolvedCartLine | null,
  quantity: number,
) => {
  if (!cartLine) {
    return
  }

  GTMResetEcommerce()

  const w = window as any

  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({
    event: 'remove_from_cart',
    ecommerce: {
      items: [
        createItem({
          productTitle: cartLine.merchandise.product.title,
          currency: cartLine.merchandise.priceV2.currencyCode,
          index: 0,
          variantTitle: cartLine.merchandise.title,
          priceAmount: cartLine.merchandise.priceV2.amount,
          quantity,
        }),
      ],
    },
  })
}
